/* eslint-disable */
Number.isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' &&
    isFinite(value) &&
    Math.floor(value) === value
}

import 'intersection-observer'



// WEBPACK FOOTER //
// ./src/v1/client.polyfill.js